import { render, staticRenderFns } from "./EntityFormPage.vue?vue&type=template&id=f7af96f4&scoped=true"
import script from "./EntityFormPage.vue?vue&type=script&lang=js"
export * from "./EntityFormPage.vue?vue&type=script&lang=js"
import style0 from "./EntityFormPage.vue?vue&type=style&index=0&id=f7af96f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7af96f4",
  null
  
)

export default component.exports